import { render, staticRenderFns } from "./multiselect-input.vue?vue&type=template&id=2a50a330"
import script from "./multiselect-input.vue?vue&type=script&lang=ts"
export * from "./multiselect-input.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports